import { Link } from "react-router-dom";
import TopNav from "@/components/TopNav";
import { Button } from "@/components/ui/button";

export default function Signup() {
  return (
    <div className="min-h-screen bg-white">
      <TopNav />
      <div className="max-w-[1280px] mx-auto px-5 sm:px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="fx-mono-tag mb-4">§ PRE-LAUNCH ACCESS</div>
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight leading-tight">
            Public registration is currently closed.
          </h1>
          <p className="mt-5 text-[#475569] max-w-md leading-relaxed">
            Agenaix is completing its launch preparations. New customer accounts
            are not being accepted at this time.
          </p>
        </div>

        <div className="md:col-span-6 md:col-start-7 border border-[#DCE3ED] p-8 lg:p-10 bg-white rounded-xl">
          <div className="fx-mono-tag mb-3">EXISTING ACCESS</div>
          <h2 className="text-xl sm:text-2xl font-bold tracking-tight text-[#172033]">
            Already have an authorised account?
          </h2>
          <p className="mt-3 text-sm text-[#475569] leading-relaxed">
            Existing authorised users can continue to sign in. For launch or
            access enquiries, contact agenaix.ai@gmail.com.
          </p>

          <div className="mt-7 space-y-3">
            <Link to="/login">
              <Button className="fx-btn-primary h-11 w-full rounded-lg text-sm font-semibold">
                Sign in →
              </Button>
            </Link>
            <a
              href="mailto:agenaix.ai@gmail.com"
              className="flex h-11 w-full items-center justify-center rounded-lg border border-[#DCE3ED] text-sm font-semibold text-[#172033] hover:bg-[#F4F6F8]"
            >
              Contact Agenaix
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
